﻿/* ─────────────────────────────────────────
   NUPOP ARCA — theme.js
   Global JS: mobile menu, scroll dots, cart
   ───────────────────────────────────────── */

/* ── MOBILE MENU ─────────────────────── */
const menuToggle  = document.getElementById('menu-toggle');
const menuOverlay = document.getElementById('menu-overlay');
const menuClose   = document.getElementById('menu-close');

if (menuToggle && menuOverlay) {
  menuToggle.addEventListener('click', () => {
    const open = menuOverlay.classList.toggle('open');
    menuToggle.classList.toggle('open', open);
  });
  if (menuClose) menuClose.addEventListener('click', () => {
    menuOverlay.classList.remove('open');
    menuToggle.classList.remove('open');
  });
  menuOverlay.querySelectorAll('a').forEach(a =>
    a.addEventListener('click', () => {
      menuOverlay.classList.remove('open');
      menuToggle.classList.remove('open');
    })
  );
}

/* ── SCROLL DOTS ─────────────────────── */
const scrollDotEls = document.querySelectorAll('.scroll-dot');
const DOT_COUNT    = scrollDotEls.length;
let _scrollTarget = null, _scrollFn = null;

function updateDots(el) {
  const max = el.scrollHeight - el.clientHeight;
  const pct = max > 0 ? el.scrollTop / max : 0;
  const active = Math.round(pct * (DOT_COUNT - 1));
  scrollDotEls.forEach((d, i) => d.classList.toggle('active', i === active));
}

function attachScrollDots(el) {
  if (_scrollTarget && _scrollFn) _scrollTarget.removeEventListener('scroll', _scrollFn);
  _scrollTarget = el;
  _scrollFn = () => updateDots(el);
  el.addEventListener('scroll', _scrollFn);
  updateDots(el);
  document.getElementById('scroll-dots').style.display = 'flex';
}

/* Attach to scrollable page content on load */
const pageWrap = document.getElementById('page-wrap');
if (pageWrap && pageWrap.scrollHeight > pageWrap.clientHeight) {
  attachScrollDots(pageWrap);
}

/* ── CART BUBBLE UPDATE ──────────────── */
function updateCartCount(count) {
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = '(' + count + ')';
  });
  const btn = document.getElementById('cart-btn');
  if (btn && btn.childNodes[0] && btn.childNodes[0].nodeType === 3) {
    btn.childNodes[0].textContent = '(' + count + ') ';
  }
}

/* Screen-reader announcements for cart activity. Without this, everything below
   updates silently for anyone not looking at the button. */
function cartAnnounce(msg) {
  let live = document.getElementById('cart-live-region');
  if (!live) {
    live = document.createElement('div');
    live.id = 'cart-live-region';
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    live.className = 'visually-hidden';
    document.body.appendChild(live);
  }
  live.textContent = msg;
}

/* Shopify returns 422 with a JSON body for "out of stock" / "you can only add N".
   That resolves like any other response, so without an explicit r.ok check a
   failed add reported success and the shopper believed the item was in the cart. */
function cartFetch(url, payload) {
  return fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(payload),
  }).then(r => r.json().then(body => {
    if (!r.ok) {
      const err = new Error((body && (body.description || body.message)) || 'Cart update failed');
      err.cartBody = body;
      throw err;
    }
    return body;
  }));
}

/* ── ADD TO CART ─────────────────────── */
document.addEventListener('click', e => {
  const btn = e.target.closest('.detail-add-btn[data-variant-id]');
  if (!btn) return;
  e.preventDefault();
  if (btn.disabled) return;

  const variantId = btn.dataset.variantId;
  const original  = btn.dataset.label || (btn.dataset.label = btn.textContent.trim());
  btn.textContent = 'Adding…';
  btn.disabled = true;

  cartFetch('/cart/add.js', { id: variantId, quantity: 1 })
    .then(() => fetch('/cart.js').then(r => r.json()))
    .then(cart => {
      updateCartCount(cart.item_count);
      btn.textContent = 'Added';
      btn.classList.add('added');
      btn.classList.remove('cart-error');
      cartAnnounce('Added to cart. ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ' in cart.');
      setTimeout(() => { btn.textContent = original; btn.classList.remove('added'); }, 1800);
    })
    .catch(err => {
      /* Surface the reason instead of silently reverting. */
      btn.textContent = err.message === 'Cart update failed' ? 'Unavailable' : 'Unavailable';
      btn.classList.add('cart-error');
      cartAnnounce(err.message || 'Could not add to cart.');
      setTimeout(() => { btn.textContent = original; btn.classList.remove('cart-error'); }, 3000);
    })
    .then(() => { btn.disabled = false; });
});

/* ── CART QTY BUTTONS ────────────────── */
/* Quantity is tracked in JS rather than re-read from the DOM on every click:
   the old code computed from qtyEl.textContent, so three fast taps on "+" all
   read the same stale value and sent 2,2,2 instead of 2,3,4. */
document.addEventListener('click', e => {
  const btn = e.target.closest('.cart-qty-btn');
  if (!btn) return;
  const row = btn.closest('.cart-item') || btn.parentElement;
  if (row.dataset.cartBusy === '1') return;

  const line  = btn.dataset.line;
  const delta = parseInt(btn.dataset.delta, 10);
  const qtyEl = btn.parentElement.querySelector('.cart-qty-val');
  const newQty = Math.max(0, parseInt(qtyEl.textContent, 10) + delta);

  row.dataset.cartBusy = '1';
  row.querySelectorAll('.cart-qty-btn, .cart-remove-btn').forEach(b => { b.disabled = true; });

  cartFetch('/cart/change.js', { line: line, quantity: newQty })
    .then(cart => {
      cartAnnounce(newQty === 0 ? 'Item removed from cart.' : 'Quantity updated to ' + newQty + '.');
      updateCartCount(cart.item_count);
      location.reload();
    })
    .catch(err => {
      row.dataset.cartBusy = '';
      row.querySelectorAll('.cart-qty-btn, .cart-remove-btn').forEach(b => { b.disabled = false; });
      const note = document.querySelector('.cart-error-note');
      if (note) { note.textContent = err.message || 'Could not update the cart.'; note.hidden = false; }
      cartAnnounce(err.message || 'Could not update the cart.');
    });
});

/* ── CART REMOVE ─────────────────────── */
document.addEventListener('click', e => {
  const btn = e.target.closest('.cart-remove-btn');
  if (!btn) return;
  const row = btn.closest('.cart-item') || btn.parentElement;
  if (row.dataset.cartBusy === '1') return;
  row.dataset.cartBusy = '1';
  row.querySelectorAll('.cart-qty-btn, .cart-remove-btn').forEach(b => { b.disabled = true; });

  cartFetch('/cart/change.js', { line: btn.dataset.line, quantity: 0 })
    .then(cart => {
      cartAnnounce('Item removed from cart.');
      updateCartCount(cart.item_count);
      location.reload();
    })
    .catch(err => {
      row.dataset.cartBusy = '';
      row.querySelectorAll('.cart-qty-btn, .cart-remove-btn').forEach(b => { b.disabled = false; });
      const note = document.querySelector('.cart-error-note');
      if (note) { note.textContent = err.message || 'Could not remove the item.'; note.hidden = false; }
      cartAnnounce(err.message || 'Could not remove the item.');
    });
});

/* ── BACK LINK ───────────────────────── */
/* The href is a real collection URL so it works on a cold landing from search or
   a shared link. Only upgrade it to a true history step when we actually came
   from this site, and never hijack modified clicks (new tab / new window). */
document.addEventListener('click', e => {
  const link = e.target.closest('a[data-history-back]');
  if (!link) return;
  if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
  let sameOrigin = false;
  try { sameOrigin = !!document.referrer && new URL(document.referrer).origin === location.origin; }
  catch (err) { sameOrigin = false; }
  if (sameOrigin && history.length > 1) {
    e.preventDefault();
    history.back();
  }
});


/* ── HEADER SEARCH (expanding) ───────── */
/* The pill is a real submit button: closed, it opens the field instead of
   submitting; open with text, it submits; open and empty, it closes again. That
   keeps Enter-to-search working natively from the input. */
(function(){
  var box = document.getElementById('search-box');
  if (!box) return;
  var input = document.getElementById('header-search-input');
  var btn   = document.getElementById('search-box-btn');

  /* How far left the field may grow. On desktop that is the whole nav, so the
     open field reads as replacing it. Where the nav is collapsed to a menu
     button, it is everything between that button and the pill. Measured rather
     than hardcoded because the nav is merchant-editable and its width moves. */
  function expandedWidth() {
    var btnLeft = btn.getBoundingClientRect().left;
    var nav     = document.querySelector('header nav');
    var toggle  = document.querySelector('header .menu-toggle');
    var left;
    if (nav && nav.offsetParent) {
      left = nav.getBoundingClientRect().left;
    } else if (toggle && toggle.offsetParent) {
      left = toggle.getBoundingClientRect().right + 10;
    } else {
      var header = document.querySelector('header');
      var hs = header ? getComputedStyle(header) : null;
      left = header ? header.getBoundingClientRect().left + parseFloat(hs.paddingLeft || 0) : 16;
    }
    /* Never let it run off the left edge or collapse to nothing. */
    return Math.max(140, Math.min(btnLeft - left, btnLeft - 8));
  }

  function sizeField() {
    if (box.classList.contains('open')) input.style.width = expandedWidth() + 'px';
  }

  function open() {
    box.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
    input.removeAttribute('tabindex');
    input.style.width = expandedWidth() + 'px';
    input.focus();
  }
  function close() {
    box.classList.remove('open');
    btn.setAttribute('aria-expanded', 'false');
    input.setAttribute('tabindex', '-1');
    input.style.width = '';
    input.blur();
  }

  window.addEventListener('resize', sizeField);

  btn.addEventListener('click', function(e){
    if (!box.classList.contains('open')) { e.preventDefault(); open(); return; }
    if (!input.value.trim())             { e.preventDefault(); close(); }
    /* otherwise fall through and let the form submit */
  });

  input.addEventListener('keydown', function(e){
    if (e.key === 'Escape') { e.preventDefault(); close(); btn.focus(); }
  });

  /* Close on a genuine click elsewhere, never on blur alone. A blur-timer here
     collapsed the field (and discarded typed text) any time focus moved for an
     unrelated reason. mousedown so it settles before the new target focuses. */
  document.addEventListener('mousedown', function(e){
    if (box.classList.contains('open') && !box.contains(e.target) && !input.value.trim()) close();
  });
})();


/* ── MENU OVERLAY SEARCH PILL ────────── */
/* The bottom-docked mobile header has no room for a fourth control, so search
   lives in the menu. Tapping the pill turns it into a field in place. */
(function(){
  var form = document.getElementById('overlay-search');
  if (!form) return;
  var trigger = document.getElementById('overlay-search-trigger');
  var field   = document.getElementById('overlay-search-input');

  function startTyping() {
    form.classList.add('typing');
    field.removeAttribute('tabindex');
    field.focus();
  }
  function stopTyping() {
    form.classList.remove('typing');
    field.setAttribute('tabindex', '-1');
    field.value = '';
  }

  trigger.addEventListener('click', startTyping);

  field.addEventListener('keydown', function(e){
    if (e.key === 'Escape') { e.preventDefault(); stopTyping(); trigger.focus(); }
  });

  form.addEventListener('submit', function(e){
    if (!field.value.trim()) e.preventDefault();
  });

  /* Reset whenever the menu closes so it reopens as a plain pill. */
  var overlay = document.getElementById('menu-overlay');
  if (overlay) {
    new MutationObserver(function(){
      if (!overlay.classList.contains('open')) stopTyping();
    }).observe(overlay, { attributes: true, attributeFilter: ['class'] });
  }
})();


/* ── LIVE ITEM COUNT ─────────────────────
   Any element with data-live-count="<grid id>" shows how many product cards that
   grid currently holds. Rendered server-side by Liquid first so it is right with
   no JS; this keeps it true when the grid changes — the SPA builds its grids
   client-side, and a filter or a sold-out item can change the total after load.
   A MutationObserver is used rather than a one-off count so it tracks additions
   and removals rather than only the first paint. */
(function(){
  var targets = document.querySelectorAll('[data-live-count]');
  if (!targets.length) return;

  function countCards(grid){
    /* The promo tile is a card in markup but not a product. */
    return grid.querySelectorAll('.shop-card:not(.shop-card-promo)').length;
  }

  targets.forEach(function(el){
    var grid = document.getElementById(el.getAttribute('data-live-count'));
    if (!grid) return;
    var sync = function(){
      var n = countCards(grid);
      if (el.textContent.trim() !== String(n)) el.textContent = n;
    };
    sync();
    new MutationObserver(sync).observe(grid, { childList: true, subtree: true });
  });
})();

/* ── PRODUCT SVGs (used by globe + any client rendering) ── */
function makeSVG(type, dark) {
  const col = dark ? '#E8EDE2' : '#131C1E';
  const svgs = {
    chair: `<svg viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line x1="16" y1="86" x2="16" y2="12" stroke="${col}" stroke-width="2.5"/>
      <line x1="16" y1="12" x2="52" y2="12" stroke="${col}" stroke-width="2"/>
      <line x1="16" y1="30" x2="52" y2="30" stroke="${col}" stroke-width="1.5"/>
      <rect x="16" y="46" width="48" height="5" stroke="${col}" stroke-width="2" fill="none"/>
      <line x1="60" y1="51" x2="60" y2="86" stroke="${col}" stroke-width="2.5"/>
      <line x1="10" y1="86" x2="66" y2="86" stroke="${col}" stroke-width="2"/>
    </svg>`,
    table: `<svg viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6" y="28" width="68" height="7" stroke="${col}" stroke-width="2" fill="none"/>
      <line x1="16" y1="35" x2="16" y2="82" stroke="${col}" stroke-width="2.5"/>
      <line x1="64" y1="35" x2="64" y2="82" stroke="${col}" stroke-width="2.5"/>
      <line x1="16" y1="62" x2="64" y2="62" stroke="${col}" stroke-width="1.5"/>
      <line x1="8"  y1="82" x2="72" y2="82" stroke="${col}" stroke-width="2"/>
    </svg>`,
    lamp: `<svg viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="24" y="88" width="32" height="6" stroke="${col}" stroke-width="2" fill="none"/>
      <line x1="40" y1="88" x2="40" y2="20" stroke="${col}" stroke-width="2"/>
      <path d="M22 36 L40 20 L58 36 Z" stroke="${col}" stroke-width="2" fill="none"/>
      <line x1="22" y1="36" x2="58" y2="36" stroke="${col}" stroke-width="2"/>
      <line x1="28" y1="30" x2="52" y2="30" stroke="${col}" stroke-width="1"/>
    </svg>`,
    sofa: `<svg viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8"  y="54" width="64" height="14" stroke="${col}" stroke-width="2" fill="none"/>
      <rect x="8"  y="32" width="10" height="22" stroke="${col}" stroke-width="2" fill="none"/>
      <rect x="18" y="40" width="44" height="14" stroke="${col}" stroke-width="2" fill="none"/>
      <rect x="62" y="46" width="10" height="22" stroke="${col}" stroke-width="2" fill="none"/>
      <line x1="16" y1="68" x2="16" y2="80" stroke="${col}" stroke-width="2"/>
      <line x1="64" y1="68" x2="64" y2="80" stroke="${col}" stroke-width="2"/>
      <line x1="8"  y1="80" x2="72" y2="80" stroke="${col}" stroke-width="1.5"/>
    </svg>`,
    shelf: `<svg viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8" y="6" width="64" height="88" stroke="${col}" stroke-width="2" fill="none"/>
      <line x1="8" y1="36" x2="72" y2="36" stroke="${col}" stroke-width="1.5"/>
      <line x1="8" y1="64" x2="72" y2="64" stroke="${col}" stroke-width="1.5"/>
      <rect x="14" y="68" width="7"  height="26" stroke="${col}" stroke-width="1.5" fill="none"/>
      <rect x="24" y="72" width="5"  height="22" stroke="${col}" stroke-width="1.5" fill="none"/>
      <rect x="33" y="66" width="9"  height="28" stroke="${col}" stroke-width="1.5" fill="none"/>
      <rect x="46" y="70" width="6"  height="24" stroke="${col}" stroke-width="1.5" fill="none"/>
      <rect x="56" y="67" width="8"  height="27" stroke="${col}" stroke-width="1.5" fill="none"/>
    </svg>`,
    cabinet: `<svg viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="10" y="8" width="60" height="82" stroke="${col}" stroke-width="2" fill="none"/>
      <line x1="40" y1="8"  x2="40" y2="90" stroke="${col}" stroke-width="1.5"/>
      <line x1="10" y1="24" x2="70" y2="24" stroke="${col}" stroke-width="1.5"/>
      <rect x="31" y="50" width="4" height="12" stroke="${col}" stroke-width="1.5" fill="none"/>
      <rect x="45" y="50" width="4" height="12" stroke="${col}" stroke-width="1.5" fill="none"/>
      <line x1="18" y1="90" x2="18" y2="97" stroke="${col}" stroke-width="2"/>
      <line x1="62" y1="90" x2="62" y2="97" stroke="${col}" stroke-width="2"/>
    </svg>`,
    bed: `<svg viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="8"  y="24" width="12" height="44" stroke="${col}" stroke-width="2" fill="none"/>
      <rect x="60" y="46" width="12" height="22" stroke="${col}" stroke-width="2" fill="none"/>
      <rect x="8"  y="56" width="64" height="12" stroke="${col}" stroke-width="2" fill="none"/>
      <rect x="20" y="44" width="40" height="12" stroke="${col}" stroke-width="1.5" fill="none"/>
      <rect x="22" y="40" width="16" height="8"  stroke="${col}" stroke-width="1.5" fill="none"/>
      <line x1="12" y1="68" x2="12" y2="82" stroke="${col}" stroke-width="2"/>
      <line x1="68" y1="68" x2="68" y2="82" stroke="${col}" stroke-width="2"/>
      <line x1="6"  y1="82" x2="74" y2="82" stroke="${col}" stroke-width="1.5"/>
    </svg>`,
    desk: `<svg viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="6"  y="34" width="68" height="6" stroke="${col}" stroke-width="2" fill="none"/>
      <rect x="48" y="40" width="22" height="34" stroke="${col}" stroke-width="2" fill="none"/>
      <rect x="51" y="47" width="16" height="12" stroke="${col}" stroke-width="1.5" fill="none"/>
      <line x1="56" y1="53" x2="65" y2="53" stroke="${col}" stroke-width="1.5"/>
      <line x1="14" y1="40" x2="14" y2="80" stroke="${col}" stroke-width="2.5"/>
      <line x1="6"  y1="80" x2="74" y2="80" stroke="${col}" stroke-width="2"/>
    </svg>`,
    mirror: `<svg viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="18" y="8"  width="44" height="68" stroke="${col}" stroke-width="2" fill="none"/>
      <rect x="23" y="13" width="34" height="58" stroke="${col}" stroke-width="1" fill="none"/>
      <line x1="27" y1="22" x2="40" y2="22" stroke="${col}" stroke-width="1" opacity="0.5"/>
      <line x1="27" y1="30" x2="36" y2="30" stroke="${col}" stroke-width="1" opacity="0.5"/>
      <line x1="30" y1="76" x2="24" y2="94" stroke="${col}" stroke-width="2"/>
      <line x1="50" y1="76" x2="56" y2="94" stroke="${col}" stroke-width="2"/>
      <line x1="24" y1="94" x2="56" y2="94" stroke="${col}" stroke-width="2"/>
    </svg>`,
    stool: `<svg viewBox="0 0 80 100" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="14" y="28" width="52" height="6" stroke="${col}" stroke-width="2" fill="none"/>
      <line x1="22" y1="34" x2="18" y2="84" stroke="${col}" stroke-width="2.5"/>
      <line x1="58" y1="34" x2="62" y2="84" stroke="${col}" stroke-width="2.5"/>
      <line x1="20" y1="56" x2="60" y2="56" stroke="${col}" stroke-width="1.5"/>
      <line x1="19" y1="70" x2="61" y2="70" stroke="${col}" stroke-width="1"/>
      <line x1="12" y1="84" x2="68" y2="84" stroke="${col}" stroke-width="2"/>
    </svg>`,
  };
  return svgs[type] || svgs['chair'];
}

/* ── GLOBE (home page only) ──────────── */
if (document.getElementById('globe-canvas')) {
  initGlobe();
}

function initGlobe() {
  const globeProducts = window.GLOBE_PRODUCTS || [];
  const scene  = document.getElementById('scene');
  const canvas = document.getElementById('globe-canvas');
  const ctx    = canvas.getContext('2d');
  const layer  = document.getElementById('cards-layer');

  let CARD_W, CARD_H, W, H, cx, cy, R;
  const dpr = window.devicePixelRatio || 1;

  function fibonacciSphere(n) {
    const pts = [], golden = Math.PI * (Math.sqrt(5) - 1);
    for (let i = 0; i < n; i++) {
      const y = n === 1 ? 0 : (1 - (i / (n - 1)) * 2) * 0.78;
      const r = Math.sqrt(Math.max(0, 1 - y * y));
      const theta = golden * i;
      pts.push({ x: Math.cos(theta) * r, y, z: Math.sin(theta) * r });
    }
    return pts;
  }
  const BASE_POS = fibonacciSphere(globeProducts.length);

  let rotY = 0.4, rotX = 0.22, velY = 0.00067, velX = 0;
  /* Inertia tuning: the share of a flick's speed kept each frame after the
     pointer lets go, the drift the globe always settles back to, and the cap
     on one hard flick. */
  const FRICTION = 0.985, IDLE_SPIN = 0.00067, MAX_FLICK = 0.25;  /* drift matches the marquee's scroll speed on screen */
  const flick = v => Math.max(-MAX_FLICK, Math.min(MAX_FLICK, v));
  let isDragging = false, prevMX = 0, prevMY = 0, dragVelY = 0, dragVelX = 0;
  /* Where the current press started, and how far a pointer may travel before a
     release stops counting as a click. Dragging the globe ends with a click
     event on whatever card is under the cursor; without this the release would
     navigate. */
  let pressX = 0, pressY = 0;
  const DRAG_SLOP = 6;

  function resize() {
    const rect = scene.getBoundingClientRect();
    W = rect.width; H = rect.height;
    canvas.width  = Math.round(W * dpr);
    canvas.height = Math.round(H * dpr);
    canvas.style.width  = W + 'px';
    canvas.style.height = H + 'px';
    ctx.scale(dpr, dpr);
    /* Fit the globe to the part of the homepage you can see above the MORE
       button. MORE is fixed near the bottom, and on mobile the banner covers the
       bottom of #scene, so centring on the whole box ran the globe under the
       button on shorter screens. The canvas still covers the whole box. */
    const bannerEl = document.querySelector('.marquee-strip');
    const bannerTop = bannerEl && getComputedStyle(bannerEl).position === 'fixed' ? bannerEl.getBoundingClientRect().top : Infinity;
    const moreBtn = document.getElementById('home-more');
    const reserve = moreBtn ? 24 + (moreBtn.getBoundingClientRect().height || 44) + 16 : 0;
    const usableH = Math.max(120, Math.min(rect.bottom, bannerTop, window.innerHeight) - rect.top - reserve);
    /* 38% of the width, but up to 44% of the usable height: on wide, short
       screens height is the limit, and the cards hardly overhang the rim. */
    cx = W / 2; cy = usableH / 2; R = Math.min(W * 0.38, usableH * 0.44);

    // Position hint centred between viewport top and the globe's visible top edge
    const hintEl = document.getElementById('hint');
    if (hintEl && W <= 600) {
      const globeTopVP = rect.top + cy - R; // globe top in viewport coords
      const hintY = Math.max(16, globeTopVP / 2);
      hintEl.style.position  = 'absolute';
      hintEl.style.top       = (hintY - rect.top) + 'px';
      hintEl.style.bottom    = 'auto';
      hintEl.style.left      = '50%';
      hintEl.style.transform = 'translate(-50%, -50%)';
    } else if (hintEl) {
      // Clear the mobile inline positioning so the stylesheet's tablet/desktop
      // rules apply again once the viewport grows back past 600px.
      hintEl.style.position  = '';
      hintEl.style.top       = '';
      hintEl.style.bottom    = '';
      hintEl.style.left      = '';
      hintEl.style.transform = '';
    }

    CARD_W = Math.max(32, Math.round(R * 0.32));
    const imgH = Math.round(CARD_W * 1.25);
    CARD_H = imgH + Math.round(CARD_W * 0.32);
    const root = document.documentElement;
    root.style.setProperty('--fc-w',     CARD_W + 'px');
    root.style.setProperty('--fc-h',     imgH   + 'px');
    root.style.setProperty('--fc-svg-w', Math.round(CARD_W * 0.70) + 'px');
    root.style.setProperty('--fc-svg-h', Math.round(imgH   * 0.71) + 'px');
    root.style.setProperty('--fc-font',  Math.max(9, Math.round(CARD_W * 0.08)) + 'px');
  }
  window.addEventListener('resize', resize);
  resize();

  /* Cards are real anchors rather than click-handled divs, so they can be
     middle-clicked or opened in a new tab, reached by keyboard, and followed by
     crawlers to the product pages. draggable=false matters: a native link drag
     would otherwise hijack the drag-to-rotate gesture. */
  const cardEls = globeProducts.map(p => {
    const el = document.createElement('a');
    el.className = 'float-card' + (p.dark ? ' dark' : '');
    const svgType = (p.type || 'chair').toLowerCase();
    /* The product's own main image when it has one; the line drawing otherwise,
       so a product without a photo still has something on the globe. The img is
       not draggable — a native image drag would hijack drag-to-rotate. */
    const cardArt = p.img
      ? `<img src="${p.img}" alt="" loading="lazy" decoding="async" draggable="false">`
      : makeSVG(svgType, p.dark);
    el.innerHTML = `<div class="fc-img${p.img ? ' has-photo' : ''}">${cardArt}</div><div class="fc-title">${p.title}</div>`;
    el.draggable = false;
    // Data attrs for long-press preview
    el.dataset.type      = svgType;
    el.dataset.dark      = p.dark ? 'true' : 'false';
    el.dataset.title     = (p.title || '').replace(/\n/g, ' ');
    el.dataset.price     = p.sold ? 'Sold' : (p.price || '');
    el.dataset.sold      = p.sold ? 'true' : 'false';
    el.dataset.condition = p.condition || '';
    el.dataset.subheader = p.subheader || '';
    el.dataset.material  = p.material  || '';
    el.dataset.dims      = p.dims      || '';
    el.dataset.delivery  = p.delivery  || '';
    el.dataset.img       = p.img       || '';
    el.dataset.url       = p.url       || '';
    el.dataset.variantId = p.variantId || '';
    el.href = p.url || '#';
    el.addEventListener('click', e => {
      /* A release that travelled is the end of a rotation, not a click. */
      if (Math.abs(e.clientX - pressX) > DRAG_SLOP || Math.abs(e.clientY - pressY) > DRAG_SLOP) { e.preventDefault(); return; }
      if (document.getElementById('card-preview').classList.contains('active')) { e.preventDefault(); return; }
      /* Otherwise the anchor's own href does the navigating. */
    });
    layer.appendChild(el);
    return el;
  });

  function rotatePoint(px, py, pz, ry, rx) {
    const x1 = px * Math.cos(ry) - pz * Math.sin(ry);
    const z1 = px * Math.sin(ry) + pz * Math.cos(ry);
    const y2 = py * Math.cos(rx) - z1 * Math.sin(rx);
    const z2 = py * Math.sin(rx) + z1 * Math.cos(rx);
    return { x: x1, y: y2, z: z2 };
  }
  const FOV = 1100;
  function project(x, y, z) {
    const s = FOV / (FOV + z * 0.55);
    return { sx: cx + x * s, sy: cy + y * s, z };
  }
  function dAlpha(z, radius) {
    const t = Math.max(0, Math.min(1, (z + radius) / (2 * radius)));
    return 0.03 + t * 0.82;
  }

  const LAT_LINES = 9, LON_LINES = 14, SEG = 80;
  let _globeIsLight = false;
  function drawGlobe() {
    ctx.clearRect(0, 0, W, H);
    _globeIsLight = document.body.classList.contains('light');
    for (let li = 1; li < LAT_LINES; li++) {
      const lat = -Math.PI/2 + (Math.PI / LAT_LINES) * li;
      const r = Math.cos(lat) * R, yR = Math.sin(lat) * R;
      const pts = [];
      for (let s = 0; s <= SEG; s++) {
        const a = (2*Math.PI/SEG)*s;
        const rp = rotatePoint(r*Math.cos(a), yR, r*Math.sin(a), rotY, rotX);
        pts.push(project(rp.x, rp.y, rp.z));
      }
      drawDepthLine(pts, R);
    }
    for (let li = 0; li < LON_LINES * 2; li++) {
      const lon = (Math.PI / LON_LINES) * li, pts = [];
      for (let s = 0; s <= SEG; s++) {
        const lat = -Math.PI/2 + (Math.PI/SEG)*s;
        const rp = rotatePoint(Math.cos(lat)*Math.cos(lon)*R, Math.sin(lat)*R, Math.cos(lat)*Math.sin(lon)*R, rotY, rotX);
        pts.push(project(rp.x, rp.y, rp.z));
      }
      drawDepthLine(pts, R);
    }
  }
  function drawDepthLine(pts, radius) {
    for (let i = 0; i < pts.length - 1; i++) {
      const p1 = pts[i], p2 = pts[i+1];
      const a = dAlpha((p1.z + p2.z) / 2, radius);
      const lw = 0.3 + (a - 0.03) / 0.82 * 0.9;
      ctx.beginPath(); ctx.moveTo(p1.sx, p1.sy); ctx.lineTo(p2.sx, p2.sy);
      ctx.strokeStyle = `rgba(${_globeIsLight ? '13,23,24' : '232,237,226'},${a.toFixed(3)})`; ctx.lineWidth = lw; ctx.stroke();
    }
  }
  function updateCards() {
    const entries = BASE_POS.map((pos, i) => {
      const rp = rotatePoint(pos.x, pos.y, pos.z, rotY, rotX);
      const p  = project(rp.x*R, rp.y*R, rp.z*R);
      const t  = Math.max(0, Math.min(1, (rp.z + 1) / 2));
      return { i, sx: p.sx, sy: p.sy, t, z: rp.z };
    });
    entries.sort((a, b) => a.z - b.z);
    entries.forEach((e, rank) => {
      const card  = cardEls[e.i];
      const scale   = 0.22 + e.t * 0.88;
      const opacity = 0.04 + e.t * 0.96;
      card.style.transform = `translate3d(${(e.sx - CARD_W/2).toFixed(1)}px,${(e.sy - CARD_H/2).toFixed(1)}px,0) scale(${scale.toFixed(4)})`;
      card.style.opacity   = opacity.toFixed(4);
      card.style.zIndex    = rank;
      card.style.filter    = e.t < 0.5 ? `blur(${((0.5-e.t)*9).toFixed(1)}px)` : '';
    });
  }
  function tick() {
    if (!isDragging) {
      /* Inertia. A flick keeps spinning and bleeds off a little each frame
         instead of stopping dead, easing back to the idle drift. Raising
         FRICTION makes it coast longer. */
      velY = IDLE_SPIN + (velY - IDLE_SPIN) * FRICTION;
      velX = velX * FRICTION;
    }
    rotY += velY;
    const tilted = rotX + velX;
    rotX = Math.max(-0.5, Math.min(0.5, tilted));
    if (rotX !== tilted) velX = 0;  /* at the tilt limit - stop pushing into it */
    drawGlobe(); updateCards();
    requestAnimationFrame(tick);
  }

  scene.addEventListener('mousedown', e => { if (e.target.closest('.home-section, .home-nav')) return; isDragging=true; pressX=e.clientX; pressY=e.clientY; prevMX=e.clientX; prevMY=e.clientY; dragVelY=dragVelX=0; });
  window.addEventListener('mousemove', e => { if(!isDragging)return; const dY=(e.clientX-prevMX)*-0.007, dX=(e.clientY-prevMY)*-0.007; dragVelY=dragVelY*0.6+dY*0.4; dragVelX=dragVelX*0.6+dX*0.4; rotY+=dY; rotX=Math.max(-0.5,Math.min(0.5,rotX+dX)); prevMX=e.clientX; prevMY=e.clientY; });
  window.addEventListener('mouseup',  () => { isDragging=false; velY=flick(dragVelY); velX=flick(dragVelX); });
  scene.addEventListener('touchstart', e => { if (e.target.closest('.home-section, .home-nav')) return; const t=e.touches[0]; isDragging=true; pressX=t.clientX; pressY=t.clientY; prevMX=t.clientX; prevMY=t.clientY; dragVelY=dragVelX=0; }, {passive:true});
  window.addEventListener('touchmove', e => { if(!isDragging)return; const t=e.touches[0]; const dY=(t.clientX-prevMX)*-0.007, dX=(t.clientY-prevMY)*-0.007; dragVelY=dragVelY*0.6+dY*0.4; dragVelX=dragVelX*0.6+dX*0.4; rotY+=dY; rotX=Math.max(-0.5,Math.min(0.5,rotX+dX)); prevMX=t.clientX; prevMY=t.clientY; }, {passive:true});
  window.addEventListener('touchend', () => { isDragging=false; velY=flick(dragVelY); velX=flick(dragVelX); });
  scene.addEventListener('mouseenter', () => { velY=Math.max(velY,0.002); });  /* the hover nudge keeps its 3x ratio to the drift */

  tick();
}

/* ── CARD LONG-PRESS PREVIEW ─────────────── */
(function(){
  var DELAY      = 480;  // ms to trigger long-press
  var MOVE_LIMIT = 10;   // px — movement cancels the timer

  var preview  = document.getElementById('card-preview');
  var backdrop = document.getElementById('cpv-backdrop');
  var sheet    = document.getElementById('cpv-sheet');
  if (!preview) return;

  var lpTimer = null, lpFired = false;
  var startX = 0, startY = 0;

  /* ── Show ── */
  function showPreview(card) {
    lpFired = true;
    var d = card.dataset;
    var isSold = d.sold === 'true';

    document.getElementById('cpv-eyebrow').textContent =
      d.subheader || d.condition || '';
    document.getElementById('cpv-title').textContent =
      (d.title || '').toUpperCase();

    var heroEl = document.getElementById('cpv-hero');
    heroEl.className = 'card-preview-hero ' + (d.dark === 'true' ? 'dark-bg' : 'light-bg');
    if (d.img) {
      heroEl.innerHTML = '<img src="' + d.img + '" alt="' + (d.title || '') + '">';
    } else {
      heroEl.innerHTML = typeof makeSVG === 'function'
        ? makeSVG(d.type || 'chair', d.dark === 'true') : '';
    }

    var rows = [];
    if (d.material) rows.push(['Material',   d.material]);
    if (d.dims)     rows.push(['Dimensions', d.dims]);
    if (d.delivery) rows.push(['Delivery',   d.delivery]);
    document.getElementById('cpv-meta').innerHTML = rows.map(function(r){
      return '<div class="cpv-meta-row"><span class="cpv-meta-label">'+r[0]+'</span>'
           + '<span class="cpv-meta-val">'+r[1]+'</span></div>';
    }).join('');

    document.getElementById('cpv-price').textContent = isSold ? 'SOLD' : (d.price || '');
    document.getElementById('cpv-view').href = d.url || '#';

    var addBtn = document.getElementById('cpv-add');
    if (isSold) {
      addBtn.style.display = 'none';
    } else {
      addBtn.style.display = '';
      addBtn.textContent   = 'Add to Cart';
      addBtn.className     = 'card-preview-add';
      addBtn.disabled      = false;
      addBtn.dataset.variantId = d.variantId || '';
    }

    preview.setAttribute('aria-hidden', 'false');
    preview.classList.add('active');
    document.body.style.overflow = 'hidden';
    if (navigator.vibrate) navigator.vibrate(12);
  }

  /* ── Dismiss ── */
  function hidePreview() {
    preview.classList.remove('active');
    preview.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    sheet.style.transform  = '';
    sheet.style.transition = '';
  }

  /* ── Long-press detection on any shop-card ── */
  document.addEventListener('touchstart', function(e){
    var card = e.target.closest('.shop-card:not(.shop-card-promo), .float-card');
    if (!card) return;
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    lpFired = false;
    lpTimer = setTimeout(function(){ showPreview(card); lpTimer = null; }, DELAY);
  }, {passive:true});

  document.addEventListener('touchmove', function(e){
    if (!lpTimer) return;
    var dx = e.touches[0].clientX - startX;
    var dy = e.touches[0].clientY - startY;
    if (Math.abs(dx) > MOVE_LIMIT || Math.abs(dy) > MOVE_LIMIT){
      clearTimeout(lpTimer); lpTimer = null;
    }
  }, {passive:true});

  document.addEventListener('touchend', function(){
    if (lpTimer){ clearTimeout(lpTimer); lpTimer = null; }
  }, {passive:true});

  /* Block link navigation when preview was triggered */
  document.addEventListener('click', function(e){
    var card = e.target.closest('.shop-card, .float-card');
    if (card && lpFired){ e.preventDefault(); lpFired = false; }
  }, true);

  /* ── Backdrop tap to dismiss ── */
  backdrop.addEventListener('click', hidePreview);

  /* ── Add to Cart (Shopify fetch) ── */
  /* Routed through cartFetch so a 422 (out of stock / limit reached) is treated
     as a failure. This copy previously reported "Added ✓" on any response. */
  document.getElementById('cpv-add').addEventListener('click', function(){
    var btn   = this;
    var varId = parseInt(btn.dataset.variantId);
    if (!varId || btn.disabled) return;
    btn.textContent = 'Adding…';
    btn.disabled = true;
    cartFetch('/cart/add.js', { id: varId, quantity: 1 })
      .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
      .then(function(cart){
        updateCartCount(cart.item_count);
        btn.textContent = 'Added';
        btn.classList.add('added');
        btn.disabled = false;
        cartAnnounce('Added to cart. ' + cart.item_count + ' item' + (cart.item_count === 1 ? '' : 's') + ' in cart.');
        setTimeout(hidePreview, 900);
      })
      .catch(function(err){
        btn.textContent = 'Unavailable';
        btn.classList.add('cart-error');
        btn.disabled = false;
        cartAnnounce(err.message || 'Could not add to cart.');
        setTimeout(function(){ btn.textContent = 'Add to Cart'; btn.classList.remove('cart-error'); }, 3000);
      });
  });

  /* ── Swipe sheet down to dismiss ── */
  var swipeY0 = 0, swipeActive = false;
  sheet.addEventListener('touchstart', function(e){
    swipeY0 = e.touches[0].clientY;
    swipeActive = true;
    sheet.style.transition = 'none';
  }, {passive:true});
  sheet.addEventListener('touchmove', function(e){
    if (!swipeActive) return;
    var dy = e.touches[0].clientY - swipeY0;
    if (dy < 0) sheet.style.transform = 'translateY('+dy+'px)'; // drag up only
  }, {passive:true});
  sheet.addEventListener('touchend', function(e){
    swipeActive = false;
    var dy = e.changedTouches[0].clientY - swipeY0;
    sheet.style.transition = '';
    if (dy < -60) { hidePreview(); } else { sheet.style.transform = ''; } // swipe up to dismiss
  }, {passive:true});
})();

/* ── MARQUEE DRAG ────────────────────────── */
(function(){
  const strip = document.querySelector('.marquee-strip');
  const inner = document.querySelector('.marquee-inner');
  if (!strip || !inner) return;

  // Kill CSS animation — we drive it in JS
  inner.style.animation = 'none';

  const FPS = 60, DURATION_S = 126.7;  /* 30% of the original 38s scroll speed */
  let pos = 0, vel = 0;
  let dragging = false, dragStartX = 0, dragStartPos = 0;
  let lastMoveX = 0, lastMoveT = 0;

  function loopWidth() { return inner.scrollWidth / 4; }
  function autoSpeed()  { return -(loopWidth() / (DURATION_S * FPS)); }

  function wrap(p) {
    const w = loopWidth();
    while (p <= -w) p += w;
    while (p >   0) p -= w;
    return p;
  }

  function tick() {
    if (!dragging) {
      const target = autoSpeed();
      vel += (target - vel) * 0.05; // ease back to auto-scroll speed on release
      pos = wrap(pos + vel);
    }
    inner.style.transform = 'translateX(' + pos + 'px)';
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);

  function onStart(x) {
    dragging = true;
    dragStartX = x;
    dragStartPos = pos;
    lastMoveX = x;
    lastMoveT = performance.now();
    vel = 0;
    strip.classList.add('dragging');
  }

  function onMove(x) {
    if (!dragging) return;
    const now = performance.now();
    const dt = now - lastMoveT || 16;
    vel = (x - lastMoveX) / dt * (1000 / FPS);
    lastMoveX = x;
    lastMoveT = now;
    pos = wrap(dragStartPos + (x - dragStartX));
  }

  function onEnd() {
    dragging = false;
    strip.classList.remove('dragging');
    // vel carries over as momentum, then decays toward autoSpeed()
  }

  strip.addEventListener('mousedown',  e => { e.preventDefault(); onStart(e.clientX); });
  window.addEventListener('mousemove', e => { if (dragging) onMove(e.clientX); });
  window.addEventListener('mouseup',   onEnd);
  strip.addEventListener('touchstart', e => onStart(e.touches[0].clientX), {passive:true});
  window.addEventListener('touchmove', e => { if (dragging) onMove(e.touches[0].clientX); }, {passive:true});
  window.addEventListener('touchend',  onEnd);
})();

/* ── COLLECTION FILTERS ───────────────── */
(function () {
  const filterBtns  = document.querySelectorAll('.filter-btn');
  const shopGrid    = document.getElementById('shop-grid');
  const shopCount   = document.getElementById('shop-count');
  const filterScroll = document.getElementById('shop-filters-scroll');
  const prevBtn     = document.getElementById('filters-prev');
  const nextBtn     = document.getElementById('filters-next');

  if (!filterBtns.length || !shopGrid) return;

  function applyFilter(filter) {
    const cards = shopGrid.querySelectorAll('.shop-card');
    let visible = 0;
    cards.forEach(card => {
      const match = filter === 'all' || card.dataset.type === filter;
      card.style.display = match ? '' : 'none';
      if (match) visible++;
    });
    if (shopCount) shopCount.textContent = '(' + visible + ')';
  }

  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      filterBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      applyFilter(btn.dataset.filter);
    });
  });

  /* Scroll arrows.
     `.filters-arrow` ships as opacity:0 / pointer-events:none and only shows
     once the `.visible` class is applied, so without this the arrows never
     appeared at all — even when the filter row overflowed. Each arrow shows
     only when there is actually something to scroll toward. */
  if (filterScroll && prevBtn && nextBtn) {
    const SCROLL_AMT = 160;

    function updateArrows() {
      const max = filterScroll.scrollWidth - filterScroll.clientWidth;
      const atStart = filterScroll.scrollLeft <= 2;
      const atEnd   = filterScroll.scrollLeft >= max - 2;
      prevBtn.classList.toggle('visible', max > 2 && !atStart);
      nextBtn.classList.toggle('visible', max > 2 && !atEnd);
    }

    prevBtn.addEventListener('click', () => filterScroll.scrollBy({ left: -SCROLL_AMT, behavior: 'smooth' }));
    nextBtn.addEventListener('click', () => filterScroll.scrollBy({ left:  SCROLL_AMT, behavior: 'smooth' }));
    filterScroll.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    // Re-measure once the strip is actually laid out. The initial call can read
    // a stale width (async web-font swap changes the filter labels' extent, and
    // any hidden-then-shown container measures 0), which would leave the arrows
    // stuck in the wrong state.
    if ('ResizeObserver' in window) {
      new ResizeObserver(updateArrows).observe(filterScroll);
    }
    updateArrows();
  }
})();

/* ── HOME — MORE SECTIONS ───────────────────────────────────────────────────
   The homepage scrolls vertically inside #scene: globe, near&never, featured.
   MORE (fixed to the bottom of the screen) scrolls to the next section and BACK
   (fixed to the top) to the previous one. */
(function(){
  const scene = document.getElementById('scene');
  const more  = document.getElementById('home-more');
  if (!scene || !more || !scene.querySelector('.home-section')) return;
  const sections = [scene.querySelector('.globe-stage')].concat(Array.from(scene.querySelectorAll('.home-section')));
  const LAST = sections.length - 1;
  const smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function currentIndex() {
    const y = scene.scrollTop + 8;
    let i = 0;
    sections.forEach((s, n) => { if (s.offsetTop <= y) i = n; });
    /* A short last section can't scroll all the way to its top; reaching the
       bottom counts as being there. */
    if (scene.scrollTop > 0 && scene.scrollTop + scene.clientHeight >= scene.scrollHeight - 2) i = LAST;
    return i;
  }
  function go(n) {
    n = Math.max(0, Math.min(LAST, n));
    scene.scrollTo({ top: sections[n].offsetTop, behavior: smooth ? 'smooth' : 'auto' });
  }
  function sync() { scene.dataset.section = currentIndex(); }
  let queued = false;
  scene.addEventListener('scroll', () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; sync(); });
  }, { passive: true });
  window.homePanels = { go: n => { scene.scrollTop = sections[Math.max(0, Math.min(LAST, n))].offsetTop; sync(); } };

  scene.addEventListener('click', e => {
    if (e.target.closest('[data-home-more]')) go(currentIndex() + 1);
    else if (e.target.closest('[data-home-back]')) go(currentIndex() - 1);
  });

  /* Pin BACK and MORE to the screen at the top and bottom of the visible
     homepage area: below the header and banner, and above the banner where that
     is fixed to the bottom of the screen (mobile) or the bottom of the window,
     whichever is highest. Measured from the live layout; skipped while #scene is
     hidden (another page is open). */
  function placeNav() {
    const rect = scene.getBoundingClientRect();
    if (!rect.height) return;
    const strip = document.querySelector('.marquee-strip');
    const stripTop = strip && getComputedStyle(strip).position === 'fixed' ? strip.getBoundingClientRect().top : Infinity;
    const visibleBottom = Math.min(rect.bottom, stripTop, window.innerHeight);
    scene.style.setProperty('--home-nav-top', Math.round(Math.max(rect.top, 0) + 16) + 'px');
    scene.style.setProperty('--home-nav-bottom', Math.round(window.innerHeight - visibleBottom + 24) + 'px');
    scene.style.setProperty('--home-end-room', Math.round(rect.bottom - visibleBottom) + 'px');
    if (typeof attachScrollDots === 'function') attachScrollDots(scene);
    sync();
  }
  placeNav();
  window.addEventListener('resize', placeNav);
  window.addEventListener('load', placeNav);
  if ('ResizeObserver' in window) new ResizeObserver(placeNav).observe(scene);

  /* A sign-up posts and reloads the page at the top; bring the result (thanks or
     an error) back into view. */
  const signupStatus = scene.querySelector('.home-signup-status');
  if (signupStatus) requestAnimationFrame(() => signupStatus.scrollIntoView({ block: 'center' }));

  /* Countdown: every Tuesday at 9:00 AM Pacific, whatever the visitor's own
     time zone. The moment it reaches zero it restarts, counting down to the
     following Tuesday. */
  const cd = scene.querySelector('.home-countdown');
  if (!cd) return;
  const TZ = cd.dataset.tz || 'America/Los_Angeles';
  const WEEKDAY = Number(cd.dataset.weekday || 2);
  const HOUR = Number(cd.dataset.hour || 9);
  const DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const fmt = new Intl.DateTimeFormat('en-US', { timeZone: TZ, hourCycle: 'h23', weekday: 'short',
    year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' });
  function zoneParts(ms) {
    const o = {};
    fmt.formatToParts(new Date(ms)).forEach(p => { o[p.type] = p.value; });
    return { y: +o.year, mo: +o.month, d: +o.day, h: +o.hour % 24, mi: +o.minute, s: +o.second, wd: DAYS.indexOf(o.weekday) };
  }
  /* Wall-clock time in TZ -> real instant. Corrected twice, which settles it
     across a daylight-saving change. Day overflow (d + 7) is fine for Date.UTC. */
  function zoneToInstant(y, mo, d, h) {
    const want = Date.UTC(y, mo - 1, d, h, 0, 0);
    let t = want;
    for (let i = 0; i < 2; i++) {
      const p = zoneParts(t);
      t += want - Date.UTC(p.y, p.mo - 1, p.d, p.h, p.mi, p.s);
    }
    return t;
  }
  const cells = { d: cd.querySelector('[data-cd="d"]'), h: cd.querySelector('[data-cd="h"]'),
                  m: cd.querySelector('[data-cd="m"]'), s: cd.querySelector('[data-cd="s"]') };
  const pad = n => String(n).padStart(2, '0');
  function tick() {
    sync();  /* backup for the section state (BACK/MORE), in case a scroll event was missed */
    const now = Date.now();
    const p = zoneParts(now);
    const ahead = (WEEKDAY - p.wd + 7) % 7;
    let drop = zoneToInstant(p.y, p.mo, p.d + ahead, HOUR);
    if (now >= drop) drop = zoneToInstant(p.y, p.mo, p.d + ahead + 7, HOUR);
    let left = Math.floor((drop - now) / 1000);
    const d = Math.floor(left / 86400); left -= d * 86400;
    const h = Math.floor(left / 3600);  left -= h * 3600;
    const m = Math.floor(left / 60);    left -= m * 60;
    cells.d.textContent = pad(d); cells.h.textContent = pad(h);
    cells.m.textContent = pad(m); cells.s.textContent = pad(left);
  }
  tick();
  setInterval(tick, 1000);
})();
